<template>
    <v-container class="pt-0" fluid>
        <!--        header card -->
        <v-row>
            <v-col class="pa-0">
                <v-card>
                    <v-card-title class="font-weight-light">
                        <v-btn icon @click="toggleside=!toggleside">
                            <v-icon v-if="toggleside">{{icons.arrowleft}}</v-icon>
                            <v-icon v-else>{{icons.arrowright}}</v-icon>
                        </v-btn>
                        <v-icon color="awesome">{{icons.calendar}}</v-icon>
                        <v-btn-toggle class="ml-2 white--text" dark>
                            <v-btn small @click="Api.prev(),caltitle=Api.view.title" color="awesome">
                                <v-icon>mdi-menu-left-outline</v-icon>
                            </v-btn>
                            <v-btn small @click="Api.next(),caltitle=Api.view.title" color="awesome">
                                <v-icon>mdi-menu-right-outline</v-icon>
                            </v-btn>
                        </v-btn-toggle>
                        <v-btn class="ml-2" small outlined @click="Api.today(),caltitle=Api.view.title">Today</v-btn>
                        <v-spacer></v-spacer>
                        <span v-if="$refs.fullCalendar">{{caltitle}}</span>
                        <v-spacer></v-spacer>
                        <v-btn-toggle class="ml-2 white--text" dark>
                            <v-btn small @click="Api.changeView('dayGridMonth'), showglass=false" color="awesome">
                                month
                            </v-btn>
                            <v-btn small @click="Api.changeView('timeGridWeek'), showglass=true" color="awesome">
                                week
                            </v-btn>
                            <v-btn small @click="Api.changeView('timeGridDay'), showglass=true" color="awesome">
                                day
                            </v-btn>
                            <v-btn small @click="Api.changeView('festivalView'), showglass=true" color="awesome">
                                festival
                            </v-btn>
                        </v-btn-toggle>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col :cols="toggleside?3:1">
                <EventAdder :eventtime="activeevent" :activator="true" @done="getEventTimes()"/>
                <v-card flat v-if="toggleside">
                    <v-date-picker no-title class="elevation-0" full-width v-model="calmonth"
                                   color="awesome lighten-1"/>
                </v-card>
                <v-btn block outlined small @click="eventlistdialog=true">
                    <span v-if="toggleside">calendars</span>
                    <v-icon>{{icons.list}}</v-icon>
                </v-btn>
            </v-col>
            <v-col :cols="toggleside?9:11">
                <v-card flat height="70vh">
                    <FullCalendar
                            defaultView="dayGridMonth"
                            ref="fullCalendar"
                            timeZone="utc"
                            :header="header"
                            :plugins="calendarPlugins"
                            :views="views"
                            :weekends="true"
                            :editable="true"
                            height="parent"
                            :eventStartEditable="true"
                            :slotDuration=slotduration[slotdurationindex]
                            :eventResizableFromStart="true"
                            @dateClick="handleDateClick($event)"
                            @eventResize="handleEventMove($event)"
                            @eventDrop="handleEventMove($event)"
                            @eventClick="loadActiveDateTime($event)"
                            @datesRender="event($event)"
                            @eventRender="eventRender($event)"
                            :events="eventtimes"
                    />
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="eventlistdialog" scrollable max-width="400">
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="10">
                            <v-select item-text="name" item-value="uuid" label="festivals" v-model="activefestival"
                                      :items="festivals"/>
                        </v-col>
                        <v-col cols="2">
                            <v-btn icon x-small @click="eventlistdialog=false">
                                <v-icon>{{icons.close}}</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-list dense v-if="events">
                        <v-list-item v-for="e in displayedEvents" :key="e.id">
                            <v-list-item-avatar>
                                <v-img v-if="e.imgurl" :src="e.imgurl" size="20"/>
                                <v-img v-else :src="require('@/assets/missinggear.png')" size="20"/>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{e.name}}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-checkbox v-model="calendars" :value="e.id"/>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn-toggle>
                        <v-btn @click="eventkey='*'" :dark="eventkey==='*'">All</v-btn>
                        <v-btn @click="eventkey='active'" :dark="eventkey==='active'">Active</v-btn>
                    </v-btn-toggle>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-btn v-if="showglass" fab fixed bottom left @click="slotdurationindex===2?slotdurationindex=0:slotdurationindex++">
            <v-icon large v-if="slotdurationindex!==2">mdi-magnify-plus-outline</v-icon>
            <v-icon large v-if="slotdurationindex===2">mdi-magnify-minus-outline</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import timeGridPlugin from '@fullcalendar/timegrid'
  import interactionPlugin from '@fullcalendar/interaction'
  import {
    mapState,
    mapActions
  } from 'vuex';
  import EventAdder from "@/views/calendar/EventAdder";

  export default {
    components: {EventAdder, FullCalendar},
    name: "Calendar",
    data() {
      return {
        calendarPlugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        activeevent: undefined,
        eventdialog: false,
        eventtimes: [],
        calendars: [],
        calmonth: '',
        header: false,
        caltitle: '',
        toggleside: false,
        eventlistdialog: false,
        eventkey: 'active',
        festivals: undefined,
        activefestival: undefined,
        views: {
          festivalView: {
            type: 'timeGrid',
            visibleRange: {
              start: '2020-06-19',
              end: '2020-06-29'
            },
            buttonText: 'Festival'
          }
        },
        slotduration: ['00:60:00', '00:30:00', '00:15:00'],
        slotdurationindex:0,
        showglass: false
      }
    },
    computed: {
      ...mapState(['org', 'icons', 'events']),
      Api() {
        return this.$refs.fullCalendar.getApi()
      },
      displayedEvents() {
        if (this.eventkey === '*') {
          return this.events.filter(f => {
            return f.festivalId === this.activefestival
          })
        } else {
          return this.events.filter(f => {
            return f[this.eventkey]
          })
        }

      }
    },
    watch: {
      calendars() {
        this.getCalendars()
        window.localStorage.setItem('calendars', JSON.stringify(this.calendars))
      },
      calmonth(n) {
        this.caltitle = this.Api.view.title
      },
    },
    mounted() {
      if (window.localStorage.getItem('calendars')) {
        let c = window.localStorage.getItem('calendars')
        this.calendars = JSON.parse(c)
      }
      if (window.localStorage.getItem('caldate')) {
        let d = window.localStorage.getItem('caldate')
        d = JSON.parse(d)
        this.Api.changeView(
          d.type, d.start
        )
      }
      this.getCalendars()
      this.getFestivals()
      this.getEventTimes()
    },
    methods: {
      ...mapActions(['get', 'post', 'openGet', 'getEvents']),
      event(e) {
        //console.log(e)
      },
      async getCalendars() {
        let data = await this.post({path: 'api/caltimes/timesbyevent', body: this.calendars})
        this.eventtimes = data
        this.caltitle = this.Api.view.title
      },
      async getFestivals() {
        let data = await this.get({path: 'api/event/myfestivals'})
        data.unshift({name: "All Events", uuid: undefined})// this will handle front end. kind of risky
        this.festivals = data
      },
      async getEventTimes() {
        //let d = this.cal.getEventTimes()
        //console.log('CAL', d)
        let data = await this.get({path: 'api/caltimes/eventtimes'})
        this.eventtimes = data
      },
      eventRender(info) {
        if (info.event.extendedProps.src) {
          let c = info.el.querySelector('div.fc-content')
          c.style.paddingLeft='22px'
          let m = new Image()
          m.style.width='20px'
          m.style.height='20px'
          m.style.position='absolute'
          m.style.top='0'
          m.style.left='0'
          m.src=info.event.extendedProps.src
          c.prepend(m);
        }
      },
      handleDateClick(e) {
        console.log('DC', e)
        //note e.dateStr is really cool to use,
        //but it doenst exist in the activeeventTime() so we arent going to use it her either
        this.activeevent = {
          "allDay": e.allDay,
          "color": "#0000FF",
          "end": e.end,
          "groupId": e.groupId,
          "start": e.date,
          "dstring": e.dateStr,
          "title": 'Title',
          "eventId": undefined,
          "festivalId": undefined,
          "tournamentId": undefined,
          "otherdata": undefined
        }
      },
      loadActiveDateTime(e) {console.log(e)
        //HANDLES ALREADY-CREATED TIMES
        let ev = {
          "allDay": e.event.allDay,
          //"backgroundColor",
          //"borderColor",
          //"classNames",
          //"constraint",
          "end": e.event.end,
          "groupId": e.event.groupId,
          "id": parseInt(e.event.id),
          //"overlap",
          //"rendering",
          "start": e.event.start,
          "src":e.event.extendedProps.src,
          //"startEditable",
          //"textColor",
          "color":e.event.backgroundColor,
          "title": e.event.title,
          "description": e.event.extendedProps.description,
          "eventId": e.event.extendedProps.eventId,
          "festivalId": e.event.extendedProps.festivalId,
          "tournamentId": e.event.extendedProps.tournamentId,
          "otherdata": e.event.extendedProps
          //"url"
        }
        let em = this;
        if(this.Api.view.type === 'timeGridWeek'){
          let btn = this.createButton('mdi-file-edit')
          btn.style.position='absolute';
          btn.style.top='0'
          btn.style.left='0';
          btn.style.textAlign='center'
          btn.style.zIndex=4
          btn.classList.add('editbtn_tmp','v-btn--flat','v-btn--outlined')
          btn.style.transform = 'scale(1.4)'
          btn.addEventListener('click',function(){
            em.activeevent = ev;
          })
          e.el.append(btn)
          e.el.addEventListener('mouseleave',function(){
            btn.remove()
          })
        } else {
          this.activeevent = ev
        }
      },
      handleEvent(e) {
        this.activeevent = {
          "allDay": e.event.allDay,
          //"backgroundColor",
          //"borderColor",
          //"classNames",
          //"constraint",
          "end": e.event.end,
          "groupId": e.event.groupId,
          "id": parseInt(e.event.id),
          //"overlap",
          //"rendering",
          "start": e.event.start,
          //"startEditable",
          //"textColor",
          "title": e.event.title,
          "eventId": e.event.extendedProps.eventId,
          "festivalId": e.event.extendedProps.festivalId,
          "tournamentId": e.event.extendedProps.tournamentId
          //"url"
        }
        this.saveEventTime()
      },
      async handleEventMove(e) {
        let event = {
          "allDay": e.event.allDay,
          //"backgroundColor",
          //"borderColor",
          //"classNames",
          //"constraint",
          "end": e.event.end,
          "groupId": e.event.groupId,
          "id": parseInt(e.event.id),
          //"overlap",
          //"rendering",
          "start": e.event.start,
          //"startEditable",
          //"textColor",
          "title": e.event.title,
          "eventId": e.event.extendedProps.eventId,
          "festivalId": e.event.extendedProps.festivalId,
          "tournamentId": e.event.extendedProps.tournamentId
          //"url"
        }
        await this.post({path: 'api/caltimes/savetimev2', body: event})
        //this.getCalendars()
        this.eventdialog = false
      },
      async saveEventTime() {
        await this.post({path: 'api/caltimes/savetimev2', body: this.activeevent})
        this.getEventTimes()
        this.eventdialog = false
      },
      async deleteTime() {
        await this.post({path: 'api/caltimes/deletetime', body: this.activeevent})
        this.getCalendars()
        this.getEventTimes()
        this.eventdialog = false
      },
      setCalDate(n) {
        this.Api.gotoDate(n)
      },
      createButton(icon) {
        let btn = document.createElement('button')
        let cls = "ma-0 v-btn v-btn--depressed theme--light ripple"//this is how lazy i am
        btn.classList.add(...cls.split(' '))
        let spn = document.createElement('span')
        spn.classList.add("v-btn_content", "white--text")
        btn.appendChild(spn)
        let icn = document.createElement('icon')
        let icls = "v-icon notranslate mdi theme--light " + icon
        icn.classList.add(...icls.split(' '))
        icn.style.cssText = "color: white;"
        spn.appendChild(icn)
        btn.style.cssText = "background-color: rgba(0, 0, 0, 0.333);"
        return btn
      },
    },
    beforeRouteLeave(to, from, next) {
      let e = this.Api.view
      let cdata = {
        type: e.type,
        start: e.currentStart,
        end: e.currentEnd
      }
      window.localStorage.setItem('caldate', JSON.stringify(cdata))
      next()
    }
  }
</script>

<style lang='scss'>
    // you must include each plugins' css
    // paths prefixed with ~ signify node_modules
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';
    @import '~@fullcalendar/timegrid/main.css';

    .demo-app {
        font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
        font-size: 14px;
    }

    .demo-app-top {
        margin: 0 0 3em;
    }

    .demo-app-calendar {
        margin: 0 auto;
        max-width: 900px;
    }
</style>